
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.47 12.47a.75.75 0 101.06 1.06L.47 12.47zm5.116-4.056l.53.53-.53-.53zm2.828 0l.53-.53-.53.53zm4.056 5.116a.75.75 0 101.06-1.06l-1.06 1.06zm-2-3.06a.75.75 0 101.06 1.06l-1.06-1.06zm4.944-1.056l-.53.53.53-.53zm1.056 2.116a.75.75 0 101.06-1.06l-1.06 1.06zM11 4.25a.75.75 0 000 1.5v-1.5zm.01 1.5a.75.75 0 000-1.5v1.5zM3 1.75h12V.25H3v1.5zM16.25 3v12h1.5V3h-1.5zM15 16.25H3v1.5h12v-1.5zM1.75 15V3H.25v12h1.5zM3 16.25c-.69 0-1.25-.56-1.25-1.25H.25A2.75 2.75 0 003 17.75v-1.5zM16.25 15c0 .69-.56 1.25-1.25 1.25v1.5A2.75 2.75 0 0017.75 15h-1.5zM15 1.75c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0015 .25v1.5zM3 .25A2.75 2.75 0 00.25 3h1.5c0-.69.56-1.25 1.25-1.25V.25zM1.53 13.53l4.586-4.585-1.06-1.061L.47 12.47l1.06 1.06zm6.354-4.585l4.586 4.585 1.06-1.06-4.585-4.586-1.061 1.06zm-1.768 0a1.25 1.25 0 011.768 0l1.06-1.061a2.75 2.75 0 00-3.889 0l1.061 1.06zm5.414 2.585l1.586-1.585-1.06-1.061-1.586 1.586 1.06 1.06zm3.354-1.585l1.586 1.585 1.06-1.06-1.586-1.586-1.06 1.06zm-1.768 0a1.25 1.25 0 011.768 0l1.06-1.061a2.75 2.75 0 00-3.889 0l1.061 1.06zM11 5.75h.01v-1.5H11v1.5z"}})])
          )
        }
      }
    